module.exports = __webpack_public_path__ + "img/amsFA1.d3d2e37a.png";